<p-toast position="top-center" key="top-center"></p-toast>
<p-toast position="top-right" key="top-right"></p-toast>
<p-toast position="top-left" key="top-left"></p-toast>
<p-toast position="bottom-center" key="bottom-center"></p-toast>
<p-toast position="bottom-right" key="bottom-right"></p-toast>
<p-toast position="bottom-left" key="bottom-left"></p-toast>
<p-toast position="center" key="center"></p-toast>
<router-outlet></router-outlet>

